import * as React from "react";
import { Panel, Table } from "react-bootstrap";
import { findFieldValue } from "web_modules/underwriter_dashboard/shared";

import Money from "web_modules/Money";
import LabeledInput from "web_modules/LabeledInput";
import EditableField from "web_modules/underwriter_dashboard/shared/EditableField";
import OtherIncomeType from "./OtherIncomeType";
import NewOtherIncomeForm from "./NewOtherIncomeForm";

const FontAwesome = require("react-fontawesome");

interface IOtherIncomeSectionProps {
  docs: any;
  income: any;
  setDocId: Function;
  onChange: Function;
  hasCoborrower: boolean;
}

class OtherIncomeSection extends React.Component<IOtherIncomeSectionProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
    };
  }

  handleOnChange(field, ev) {
    let value = ev.target
      ? ev.target.type === "checkbox"
        ? ev.target.checked
        : ev.target.value
      : ev.value;
    if (value === null) {
      value = "";
    }
    this.props.onChange(field, value);
  }

  handleSelectChange(field, e) {
    this.props.onChange(field, e.hasOwnProperty("value") ? e.value : "");
  }

  handleChange(e) {
    this.props.onChange(e.target.name, e.target.value);
  }

  toggleEditing() {
    this.setState({ editing: !this.state.editing });
  }

  render() {
    const { docs, income, setDocId } = this.props;
    const { editing } = this.state;
    if (editing) {
      return (
        <NewOtherIncomeForm
          loanApplicationID={income.loan_application_id}
          additionalIncome={income}
          onCancel={this.toggleEditing.bind(this)}
          hasCoborrower={this.props.hasCoborrower}
        />
      );
    }

    return (
      <Panel>
        <FontAwesome name="pencil" onClick={this.toggleEditing.bind(this)} />
        <Table className="income_documents_review__other_income_table">
          <thead>
            <tr>
              <th>Source(s)</th>
              <th>Disclosed Description</th>
              <th>Disclosed Monthly Amount</th>
              <th>Included in Tax Returns</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {docs.length > 0 &&
                  docs.map((doc, i) => {
                    const docDescription = findFieldValue(doc, "document_description");
                    return (
                      <span key={i}>
                        <a onClick={setDocId.bind(this, doc.id)}>
                          {docDescription || "Additional Income"} [ID: {doc.id}]
                        </a>
                        <br />
                      </span>
                    );
                  })}
              </td>
              <td>{income.description}</td>
              <td>
                <Money value={income.monthly_income || 0} />
              </td>
              <td>{income.is_on_tax_returns ? "Yes" : "No"}</td>
            </tr>
          </tbody>
        </Table>
        <Table className="income_documents_review__other_income_table">
          <thead>
            <tr>
              <th>Include in Other?</th>
              <th>Actual Description</th>
              <th>Actual Monthly Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <LabeledInput
                  inputType="boolean"
                  inputValue={income.include_in_other}
                  inputName={`additionalIncome${income.id}include_in_other`}
                  onChange={this.handleOnChange.bind(this, "include_in_other")}
                />
              </td>
              <td>
                <OtherIncomeType
                  onChange={this.handleSelectChange.bind(this, "operator_income_type")}
                  selectedValue={income.operator_income_type}
                />
              </td>
              <td>
                <Money value={income.monthly_income_from_docs} />
              </td>
            </tr>
          </tbody>
        </Table>
        <dl className="income_documents_review__other_income__notes">
          <dt>Notes</dt>
          <dd>
            <EditableField
              inputType="textarea"
              inputName={`additionalIncome${income.id}notes`}
              fieldName="hi"
              originalValue=""
              changedValue={this.props.income.notes}
              handleOnChange={this.handleOnChange.bind(this, "notes")}
            />
          </dd>
        </dl>
      </Panel>
    );
  }
}

export default OtherIncomeSection;
